import styled, { keyframes } from 'styled-components';

type PullToRefreshIndicatorProps = {
  pullDistance: number;
  isRefreshing: boolean;
  threshold: number;
};

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div<{ $y: number }>`
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 8;
  display: flex;
  justify-content: center;
  pointer-events: none;
  transform: translateY(${({ $y }) => $y}px);
  transition: transform 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
`;

const Spinner = styled.div<{ $ready: boolean; $spinning: boolean }>`
  width: 32px;
  height: 32px;
  border: 3px solid ${({ theme }) => theme.colors['neutral-20']};
  border-top-color: ${({ $ready, theme }) =>
    $ready ? theme.colors['primary-60'] : theme.colors['neutral-40']};
  border-radius: 50%;
  opacity: ${({ $ready, $spinning }) => ($ready || $spinning ? 1 : 0.5)};
  animation: ${({ $spinning }) => ($spinning ? spin : 'none')} 0.7s linear infinite;
  transition: opacity 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
`;

const PullToRefreshIndicator = function ({
  pullDistance,
  isRefreshing,
  threshold,
}: PullToRefreshIndicatorProps): JSX.Element | null {
  if (pullDistance === 0 && !isRefreshing) return null;

  const y = isRefreshing ? 12 : Math.max(pullDistance - 20, 0);
  const ready = pullDistance >= threshold;

  return (
    <Wrapper $y={y}>
      <Spinner $ready={ready} $spinning={isRefreshing} />
    </Wrapper>
  );
};

export default PullToRefreshIndicator;
